<template>
  <MglMap  @load="loaded" :zoom="6" :center="center"  :accessToken="accessToken"     :mapStyle="mapStyle" >

  </MglMap>


</template>
<script>
import "mapbox-gl/dist/mapbox-gl.css";
import Vue from 'vue'
import IconContent from '../iconContent';
import PopupContent from '../popup';
import { MglMap } from "vue-mapbox";
/* webpack chunk-name firebase */
import firebase from '@firebase/app';

const mapboxgl = require('mapbox-gl');
export default {
  components: {  MglMap},
  data: () => ({
    firestore: null,
    data: [],
    PopupContent: Vue.extend(PopupContent),
    IconContent: Vue.extend(IconContent),
    center: [2.343285, 48.860174],
    mapStyle: 'mapbox://styles/mapbox/streets-v11',
    accessToken: 'pk.eyJ1Ijoic2ltb241MSIsImEiOiJjamg4dGUyZXkwNmxuM2NvNmFxN2p5cnpmIn0.G4Igc5WvjFjuIQ6UcuxLOQ',
  }),
  methods: {
    checkMapAndData() {
      if (this.data.length > 0 && this.map) {
          this.data.forEach((x) => {
            var popup = new mapboxgl.Popup({ offset: 25 }).setDOMContent(new this.PopupContent({propsData: {data : {name: x.name.fr}}}).$mount().$el);


            var el = document.createElement('div');
            el.className = 'marker';
            el.innerHTML = '<div class="vue-marker"></div>'
            new mapboxgl.Marker(el)
    .setLngLat([x.geolocation.lng, x.geolocation.lat])
    .setPopup(popup)
    .addTo(this.map);



new this.IconContent().$mount('.vue-marker')
          })
      }
    },
    loaded(e) {
      this.map = e.map;
      this.checkMapAndData();

    }
  },
  created() {
    this.map = null;
  },
  mounted() {
    this.firestore = firebase.firestore();
    let collection = this.firestore.collection('tourist_office').where('ot','==',true);
    collection.get().then((snapshot)=> {
      this.data = snapshot.docs.map((d)=> d.data()).filter(d => d.geolocation);
      this.checkMapAndData();
    });
  }
}
</script>
